import React, {
  useState,
  useRef,
  useEffect,
  SyntheticEvent,
  SetStateAction,
} from "react";
import {
  Box,
  Button,
  IconButton,
  FormControl,
  Select,
  Menu,
  MenuItem,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import TickMark from "../../assets/img/tickMark.png";
import { startSpinner, stopSpinner } from "../../store/slice/UISlice";
import PhotoGalleryIcon from "../../assets/img/photosgallery.png";
import {
  fetchImages,
  Image,
  updateLabelColor,
} from "../../store/slice/ProjectImagesUploadedSlice";
import { AppDispatch, RootState } from "../../store/store";
import {
  addProjectLabels,
  deleteProjectLabel,
  editProjectLabel,
  fetchProjectLabelById,
  fetchProjectLabels,
} from "../../store/slice/ProjectLabelSlice";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { toast } from "react-toastify";
import { selectProjectById } from "../../store/slice/ProjectSlice";
import { ProjectLabelItem } from "../../types/interface/ProjectLabel.interface";
import { CustomFabricObject, ProjectLabels } from "../Annotate";
import { fetchLabelDetails } from "../../store/slice/projectAnnotationSlice";
import { colors } from "../Annotate";
import { AnnotationData } from "./AnnotationClassification";
import GridViewIcon from '@mui/icons-material/GridView';
import { startsWith } from "lodash";
import { ImageUrlModel } from "./ClassificationImages";

interface ClassificationTopbarProps {
  gridCount: number;
  setGridCount: React.Dispatch<React.SetStateAction<number>>;
  imagesSelection: string;
  setImagesSelection: React.Dispatch<SetStateAction<string>>;
  startStop: boolean;
  setStartStop: React.Dispatch<React.SetStateAction<boolean>>;
  selectedLbl: AnnotationData;
  setSelectedLbl: React.Dispatch<React.SetStateAction<AnnotationData>>;
  taskType: string;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  count: number;
  setCount: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
  setTotalPages: React.Dispatch<React.SetStateAction<number>>;
  showLabels: boolean;
  setShowLabels: React.Dispatch<React.SetStateAction<boolean>>;
  projectId: string;
  setProjectId: React.Dispatch<React.SetStateAction<string>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  loader: boolean;
  fetchImagesAccordingto: () => Promise<void>;
  annotationImgs: ImageUrlModel[];
  setAnnotationImgs: React.Dispatch<React.SetStateAction<ImageUrlModel[]>>;
  setTotalCount?: React.Dispatch<React.SetStateAction<number>>;
  totalCount?: number;
  setAnnotatedImageCount?: React.Dispatch<React.SetStateAction<number>>;
  annotatedImageCount?: number;
}

const ClassificationTopbar: React.FC<ClassificationTopbarProps> = ({
  gridCount,
  setGridCount,
  imagesSelection,
  setImagesSelection,
  startStop,
  setStartStop,
  selectedLbl,
  setSelectedLbl,
  taskType,
  page,
  setPage,
  count,
  setCount,
  totalPages,
  setTotalPages,
  showLabels,
  setShowLabels,
  projectId,
  setProjectId,
  currentPage,
  setCurrentPage,
  loader,
  setLoader,
  fetchImagesAccordingto,
  annotationImgs,
  setAnnotationImgs,
  setTotalCount,
  totalCount,
  setAnnotatedImageCount,
  annotatedImageCount,
}) => {
  // Set initial grid count to 4
  const url = window.location.pathname;
  const segments = url.split("/");
  const lastParam = segments.pop() || "";
  const [isGalleryShown, setIsGalleryShown] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const labelRef = useRef<HTMLSelectElement>(null);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [selectedProjectLabelIdForEdit, setSelectedProjectLabelIdForEdit] =
    useState<string | null>(null);
  const canvasRef = useRef<fabric.Canvas | null>(null);
  const [labelName, setLabelName] = useState<string>("");
  const [showDiv, setShowDiv] = useState<boolean>(false);
  const [currentOption, setCurrentOption] = useState<string | null>(null);
  const selectedLabelColorRef = useRef<string>("");

  const allLabelRef = useRef<ProjectLabelItem[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [gridCount, setGridCount] = React.useState("10");
  const { labels } = useSelector((state: RootState) => state.projectLabel);
  const [selectedImage, setSelectedImage] = useState<Image | null>(null);
  const project = useSelector((state: RootState) =>
    selectProjectById(state, lastParam)
  );
  const { tasks } = useSelector((state: RootState) => state.Tasks);

  const findNameById = (id: string) => {
    const item = tasks.find((entry) => entry.id === id);
    return item ? item.name : undefined;
  };

  const handleLabelNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const sanitizedValue = e.target.value
      .replace(/^\s+/, "")
      .replace(/\s+/g, " ");
    setLabelName(sanitizedValue);
  };

  const cancelLabelCreation = () => {
    setSelectedProjectLabelIdForEdit(null);
    //setObjectTracking(false);
    setLabelName("");
    setShowDiv(false);
  };

  const handleMenuClose = () => {
    setSelectedProjectLabelIdForEdit(null);
    setAnchorEl(null);
    setCurrentOption(null);
  };


  const [deleteProjectLabelModal, setDeleteProjectLabelModal] =
    useState<boolean>(false);

  useEffect(() => {
    dispatch(fetchProjectLabels(lastParam))
      .unwrap()
      .then((response) => {
        if (response.length === 0) {
          toast.info("Add label to start annotating!");
        }
        allLabelRef.current = response;
      });
  }, []);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setCurrentOption(optionId);
  };

  const { allAnnotationImages } = useSelector(
    (state: RootState) => state.ProjectImagesUploaded
  );

  const dispatch = useDispatch<AppDispatch>();

  function lightenColor(hex: string, percent: number) {
    if (!hex) {
      const selectedLabel = labelRef.current!.value;
      const labelDetails = allLabelRef.current.find(
        (label: any) => label.id === selectedLabel
      );
      return labelDetails!.labelColor;
    }
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, "");

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let a = 0.3;

    // Increase each by the percent
    r = Math.min(255, Math.floor(r + ((255 - r) * percent) / 100));
    g = Math.min(255, Math.floor(g + ((255 - g) * percent) / 100));
    b = Math.min(255, Math.floor(b + ((255 - b) * percent) / 100));

    // Convert back to hex
    let newHex =
      "#" +
      r.toString(16).padStart(2, "0") +
      g.toString(16).padStart(2, "0") +
      b.toString(16).padStart(2, "0") +
      Math.round(a * 255)
        .toString(16)
        .padStart(2, "0");

    return newHex;
  }

  const handleProjectLabelDelete = async () => {
    try {
      dispatch(startSpinner("Deleting project label"));
      if (currentOption) {
        await dispatch(deleteProjectLabel(currentOption))
          .unwrap()
          .then((result) => {
            handleMenuClose();
            setDeleteProjectLabelModal(false);
            localStorage.setItem("popupOpen", false.toString());
            toast.success("Project Label deleted Successfully");
          });
      }
      dispatch(stopSpinner());
    } catch (e) {
      setDeleteProjectLabelModal(false);
      localStorage.setItem("popupOpen", false.toString());
      handleMenuClose();
      dispatch(stopSpinner());
    }
  };

  const handleDeleteLabelClose = () => {
    setDeleteProjectLabelModal(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  useEffect(() => {
    if (labels.length > 0) {
      setSelectedValue(labels[0].id); // Set to first label's ID by default
      setSelectedColor(labels[0].labelColor); // Set corresponding color
    }
  }, [labels]);

  const handleLabelColorChange = (event: SelectChangeEvent<string>) => {
    setSelectedColor(event.target.value);
  };

  const handleLabelChange = (
    event: SelectChangeEvent<string>,
    lblColor: any
  ) => {
    if (event.target.value === "button event") {
      setSelectedValue("");
    } else {
      setSelectedValue(event.target.value);
    }

    setSelectedLbl({ ...selectedLbl, labelColor: lblColor });
  };

  useEffect(() => {
    setSelectedLbl({
      ...selectedLbl,
      projectLabelId: selectedValue,
      projectId: lastParam,
      annotation: "",
      type: "Label",
      annotationId: "",
    });
  }, [selectedValue]);

  const handleEditProjectLabel = async () => {
    if (currentOption) {
      setSelectedProjectLabelIdForEdit(currentOption);
      const response = await dispatch(fetchProjectLabelById(currentOption));
      const editableResult = response.payload[0];
      setLabelName(editableResult.name);
      setSelectedColor(editableResult.labelColor);
      //setObjectTracking(editableResult.objectTracking);
      setShowDiv(true);
      setAnchorEl(null);
    }
  };

  const saveAnnotationLabel = async (e: React.FormEvent) => {
    toast.dismiss();
    e.preventDefault();

    if (!labelName) {
      toast.error("Please enter Label Name");
      return;
    }
    if (!selectedColor) {
      console.log(colors);
      toast.error("Please select Label Color");
      return;
    }

    const taskId: string | undefined = project?.taskTypeId;
    const taskName = taskId ? findNameById(taskId) : "Invalid ID";

    let objectTrackingVariable = false;

    if (taskName?.toLowerCase().includes("tracking")) {
      objectTrackingVariable = true;
    }

    const data = {
      id: selectedProjectLabelIdForEdit ? selectedProjectLabelIdForEdit : "",
      name: labelName.trim(),
      description: "Default Description",
      projectId: lastParam || "",
      type: "Label",
      objectTracking: objectTrackingVariable,
      // slNo: 1,
      labelColor: selectedColor,
    };
    dispatch(startSpinner("Saving project label"));

    try {
      if (selectedProjectLabelIdForEdit) {
        await dispatch(editProjectLabel(data))
          .unwrap()
          .then(() => {
            const data = {
              labelId: selectedProjectLabelIdForEdit,
              color: selectedColor,
            };
            dispatch(updateLabelColor(data));
            if (selectedImage) {
              const fillColor = lightenColor(selectedColor, 0);
              selectedImage.annotations.map((anno) => {
                for (let object of canvasRef.current!.getObjects()) {
                  const fabricObject = object as CustomFabricObject;
                  if (anno.lableId === selectedProjectLabelIdForEdit) {
                    if (fabricObject.id === anno.annotationId) {
                      object.set("fill", fillColor);
                      canvasRef.current!.renderAll();
                    }
                  }
                }
              });

              dispatch(fetchLabelDetails(selectedImage.id));

              if (selectedProjectLabelIdForEdit === selectedValue) {
                selectedLabelColorRef.current = selectedColor;
              }
            }
            toast.success("Project Label updated Successfully");
          });
        await dispatch(fetchProjectLabels(lastParam));
      } else {
        await dispatch(addProjectLabels(data))
          .unwrap()
          .then((response) => {
            allLabelRef.current = [...allLabelRef.current, response];
            toast.success("Project Label added Successfully");
          });
      }
    } catch (error) {
      //toast.error("Failed to save Label");
    } finally {
      dispatch(stopSpinner());
      setShowDiv(false);
      //setObjectTracking(false);
      setLabelName("");
      setSelectedProjectLabelIdForEdit(null);
    }
  };

  // useEffect(() => {
  //   fetchClassificationImages(1, 60);
  // }, []);

  const handleButtonClick = (event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedProjectLabelIdForEdit(null);
    setLabelName("");

    // Set a random label color from the colors list
    if (colors && colors.length > 0) {
      const randomIndex = Math.floor(Math.random() * colors.length);
      setSelectedColor(colors[randomIndex].value);
    } else {
      setSelectedColor("");
    }

    setShowDiv(true);
  };


  const handleGridLayout = (event: SelectChangeEvent) => {
    const newGridCount = Number(event.target.value);
    setGridCount(newGridCount);
    // Set count according to grid selection
    let count = 4;
    switch (newGridCount) {
      case 2:
        count = 2;
        break;
      case 4:
        count = 4;
        break;
      case 8:
        count = 8;
        break;
      case 16:
        count = 16;
        break;
      default:
        count = 4;
    }
  };



  // Filter images based on imagesSelection, then remove duplicates
  const filteredAnnotationImages = allAnnotationImages
    .filter((item) => {
      if (imagesSelection === "all") return true;
      if (imagesSelection === "annotated") return item.annotationsCount > 0;
      if (imagesSelection === "unannotated") return item.annotationsCount === 0;
      return true;
    })
    .filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.thumbUrl === item.thumbUrl)
    );

  useEffect(() => {
    // setGridCount(4); // Set initial grid count to 4 on mount

    // Check for imageToAnnotateId in localStorage and select the image if present, after mount
    setTimeout(() => {
      const imageToAnnotateId = localStorage.getItem('imageToAnnotateId');
      if (imageToAnnotateId && filteredAnnotationImages.length > 0) {
        const foundIndex = filteredAnnotationImages.findIndex(img => img.id === imageToAnnotateId);
        if (foundIndex !== -1) {
          console.log("Found image to annotate:", foundIndex);
          handleGalleryImageClick(foundIndex);
        }
      }
      // Optionally, remove the key after use
      localStorage.removeItem('imageToAnnotateId');
    }, 0);
  }, [setGridCount, filteredAnnotationImages]);

  const handleGalleryImageClick = (filteredIndex: number) => {


    setCurrentIndex(filteredIndex);
    const newPage = Math.floor(filteredIndex / count) + 1;
    setPage(newPage);
    console.log(
      "Set page to",
      newPage,
      "for filtered image index",
      filteredIndex,
      "with count",
      count
    );
  };

  return (
    <Box
      sx={{
        position: "absolute",
        left: "0",
        zIndex: "1",
        display: "flex",
        gap: "5px",
        justifyContent: "space-between",
        width: "100%",
        padding: "4px 0",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          <img
            id="imageBox"
            src={PhotoGalleryIcon}
            alt=""
            style={{
              height: "30px",
              /* background: red; */
              boxShadow: " 0 0 3px grey",
              marginLeft: "10px",
              borderRadius: "4px",
              padding: "3px",
              cursor: "pointer",
            }}
            onClick={() => setIsGalleryShown(!isGalleryShown)}
          />
        </div>
        <Box>
          <Select
            sx={{
              width: "270px",
              background: "#0000001A",
              borderRadius: "6px",
              boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
              color: "#ffffff",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderColor: "transparent",
              },
            }}
            value={selectedValue}
            onChange={(e) => {
              const selectedLabel = labels.find(
                (label) => label.id === e.target.value
              );
              handleLabelChange(e, selectedLabel?.labelColor);
            }}
            inputRef={labelRef}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            size="small"
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: "300px",
                  width: 250,
                  position: "relative",
                },
              },
            }}
            renderValue={(selected) => {
              const selectedLabel = labels.find(
                (label) => label.id === selected
              );
              return selectedLabel ? (
                <Box
                  id="addSelectLabel"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    style={{
                      height: "17px",
                      width: "17px",
                      background: selectedLabel.labelColor,
                      borderRadius: "4px",
                      marginRight: "10px",
                      display: "inline-block",
                    }}
                  ></span>
                  <abbr
                    style={{
                      textOverflow: "ellipsis",
                      textDecoration: "none",
                      width: "215px",
                      overflow: "hidden",
                    }}
                  >
                    {selectedLabel.name}
                  </abbr>
                </Box>
              ) : (
                //  {labels.length > 0 ? <em>Select Label</em> : <em>Add Label</em>}
                //   {labels.length > 0 ? (
                //   <em>Select Label</em>
                // ) : (
                //   <em>Add Label</em>
                // )}
                // <em>{labels.length > 0 ? "Select/ Add Label" : "Add Label"}</em>
                <em>Select/ Add Label</em>
              );
            }}
          >
            {/* <MenuItem value="" disabled selected>
                                {labels.length > 0 ? (
                                  <em>Select/ Add Label</em>
                                ) : (
                                  <em>Add Label</em>
                                )}
                              </MenuItem> */}

            {showDiv && (
              <div
                style={{
                  background: "white",
                  position: "sticky",
                  top: "47px",
                  zIndex: "11",
                }}
              >
                <form
                  onSubmit={saveAnnotationLabel}
                  style={{ boxShadow: "0 2px 11px #00000047" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "17px",
                    }}
                  >
                    <TextField
                      id="standard-basic"
                      label="id"
                      variant="standard"
                      type="hidden"
                      value={selectedProjectLabelIdForEdit}
                    />
                    <span
                      style={{
                        height: "17px",
                        width: "17px",
                        background: selectedColor,
                        borderRadius: "4px",
                        marginRight: "10px",
                      }}
                    >
                      <Select
                        value={selectedColor}
                        onChange={handleLabelColorChange}
                        sx={{
                          padding: "0",
                          height: "15px",
                          width: "17px",
                          border: "none",
                          "& .MuiInputBase-input": {
                            border: "none",
                            padding: "0!important",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                            padding: "0",
                          },
                        }}
                        IconComponent={() => null} // This removes the arrow
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: "150px",
                              width: 250,
                            },
                          },
                        }}
                        renderValue={(selected) => {
                          return (
                            <span
                              style={{
                                flex: "0 0 7%",
                                height: "17px",
                                width: "17px",
                                background: selected,
                                borderRadius: "4px",
                                marginRight: "10px",
                              }}
                            ></span>
                          );
                        }}
                      >
                        {colors.map((color) => (
                          <MenuItem key={color.value} value={color.value}>
                            <span
                              style={{
                                flex: "0 0 7%",
                                height: "17px",
                                width: "17px",
                                background: color.value,
                                borderRadius: "4px",
                                marginRight: "10px",
                              }}
                            ></span>
                            {color.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </span>
                    <input
                      type="text"
                      placeholder="Label Name"
                      onKeyDown={(event) => event.stopPropagation()}
                      value={labelName}
                      onChange={handleLabelNameChange}
                      maxLength={50}
                      style={{
                        padding: "8px 9px 9px 15px",
                        fontSize: "16px",
                        outline: "none",
                        margin: "5px 0",
                        width: "85%",
                        flex: "0 0 75%",
                        backgroundColor: "#F5F5F5",
                        border: "1px solid grey",
                        borderRadius: "4px",
                      }}
                    ></input>
                  </div>
                  {/* <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingLeft: "17px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        id="object-tracking"
                                        name="object-tracking"
                                        checked={objectTracking}
                                        onChange={(e) =>
                                          setObjectTracking(e.target.checked)
                                        }
                                      ></input>
                                      <label htmlFor="object-tracking">
                                        Object Tracking
                                      </label>
                                    </div> */}
                  <Box sx={{ padding: "2px" }}>
                    <Button type="submit">Save</Button>
                    <Button onClick={cancelLabelCreation}>Cancel</Button>
                  </Box>
                </form>
              </div>
            )}
            {labels.map((label) => (
              <MenuItem value={label.id} id={label.id} key={label.id}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        height: "17px",
                        width: "17px",
                        minWidth: "17px",
                        background: label.labelColor,
                        borderRadius: "4px",
                        marginRight: "10px",
                        display: "inline-block",
                      }}
                    ></span>
                    <abbr
                      title={label.name}
                      style={{
                        textOverflow: "ellipsis",
                        textDecoration: "none",
                        width: "178px",
                        overflow: "hidden",
                      }}
                    >
                      {label.name}
                    </abbr>
                  </Box>
                  <IconButton
                    size="small"
                    onClick={(e) => handleMenuOpen(e, label.id)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </Box>
              </MenuItem>
            ))}
          </Select>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleEditProjectLabel}>Edit</MenuItem>
            <MenuItem
              onClick={() => {
                setDeleteProjectLabelModal(true);
                localStorage.setItem("popupOpen", true.toString());
              }}
            >
              Delete
            </MenuItem>
          </Menu>
        </Box>
        {startStop ? (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ height: "38px!important", background: "red" }}
            onClick={(e: any) => setStartStop(false)}
            disabled={labels.length === 0}
            id="stopAnnotate"
          >
            Stop
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ height: "38px!important" }}
            onClick={(e: any) => {
              setStartStop(true);
            }}
            disabled={labels.length === 0 || selectedValue === ""}
            id="startAnnotate"
          >
            Start
          </Button>
        )}
      </div>
      <Box
        sx={{
          // position: "absolute",
          // bottom: annotationImages.length > 0 ? "70px" : "15px",
          borderRadius: "6px",
          width: "100%",
          textAlign: "center",
          //zIndex: "99",
          display: "flex",
          justifyContent: "end",
          gap: "10px",
        }}
      >
        <Box>

          <FormControl fullWidth >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
              {showLabels ? (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{
                    height: "38px!important",
                    background: "#E3F2FD", // lighter blue for "Hide Labels"
                    color: "#1565c0",
                    borderColor: "#1565c0",
                    fontWeight: 600,
                    "&:hover": {
                      background: "#BBDEFB",
                      borderColor: "#1976d2",
                    },
                  }}
                  onClick={() => setShowLabels(false)}
                  disabled={labels.length === 0 || startStop}
                  id="hideLabels"
                  title={
                    startStop
                      ? "Annotation start is turned on. Labels can be shown only when you stop annotating."
                      : ""
                  }
                >
                  Hide Labels
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{
                    height: "38px!important",
                    background: "#E8F5E9", // light green for "Show Labels"
                    color: "#388e3c",
                    borderColor: "#388e3c",
                    fontWeight: 600,
                    "&:hover": {
                      background: "#C8E6C9",
                      borderColor: "#2e7d32",
                    },
                  }}
                  onClick={() => setShowLabels(true)}
                  disabled={labels.length === 0 || selectedValue === "" || startStop}
                  id="showLabels"
                  title={
                    startStop
                      ? "Annotation start is turned on. Labels can be shown only when you stop annotating."
                      : ""
                  }
                >
                  Show Labels
                </Button>
              )}
              <Select
                sx={{
                  height: "38px",
                  width: "120px",
                  background: "#0000001A",
                  border: "none",
                  boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                  color: "#ffffff",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-select": {
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#666666",
                  },
                }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={gridCount !== undefined ? gridCount.toString() : "4"}
                onChange={handleGridLayout}
                label=""
              >
                <MenuItem value={2}><GridViewIcon /> X 2</MenuItem>
                <MenuItem value={4}><GridViewIcon /> X 4</MenuItem>
                <MenuItem value={8}><GridViewIcon /> X 8</MenuItem>
                <MenuItem value={16}><GridViewIcon /> X 16</MenuItem>
              </Select>
            </Box>

          </FormControl>
        </Box>
        {/* <Draggable bounds="parent"> */}
        <Box
          sx={{
            // background: "#00000066",
            width: "fit-content",
            padding: "0",
            // borderRadius: "6px",
            // boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
            // position: "relative",
            zIndex: "999",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: "500" }}>Show Me</span>
          <FormControl
            id="annotationFilter"
            sx={{ width: "250px" }}
            size="small"
          >
            <Select
              labelId="filterByLabel"
              id="filterByLabel"
              value={imagesSelection}
              // label="Filter By Dataset"
              onChange={(e: any) => setImagesSelection(e.target.value)}
              sx={{
                height: "38px",
                background: "#DDE7EB",
                border: "none",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& .MuiSelect-select": {
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#666666",
                },
              }}
            // InputLabelProps={{
            //   style: { fontSize: "14px" }, // Adjust the font size here
            // }}
            >
              <MenuItem value="all">All Images({totalCount})</MenuItem>
              <MenuItem
                value="annotated"
              //   disabled={annotatedImgCount === 0}
              >
                Annotated Images({annotatedImageCount})
              </MenuItem>
              <MenuItem
                value="unannotated"
              // disabled={unAnnotatedImageCount === 0}
              >
                Unannotated Images({(totalCount ?? 0) - (annotatedImageCount ?? 0)})
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* </Draggable> */}
      </Box>
      {filteredAnnotationImages.length > 0 ? (
        <div
          className={isGalleryShown ? "toggled" : "not-toggled"}
          // ref={observerRef}
          // onScroll={handleScroll}
          style={{
            background: "#414749ad",
            position: "absolute",
            overflow: "scroll",
            zIndex: "999",
            padding: "10px",
            top: "45px",
            left: "10px",
          }}
        >
          <Box
            sx={{
              display: "grid",
              // overflow: "scroll",
              gridTemplateColumns: "repeat(2, 1fr)",
              // background: "red",
              gap: "6px",
              background: "#212D32B2",
            }}
          >
            {filteredAnnotationImages.map((item, filteredIndex) => (
              <Box
                key={filteredIndex}
                data-index={filteredIndex}
                sx={{
                  position: "relative",
                  height: "fit-content",
                  width: "100%",
                  margin: "auto",
                  border: !item.isAnnotator ? "2.5px dashed #1976d2" : "1.5px solid #E0E0E0",
                  boxShadow: !item.isAnnotator
                    ? "0 0 8px 2px rgba(25, 118, 210, 0.15)"
                    : "0 1px 4px 0 rgba(0,0,0,0.04)",
                  transition: "border 0.2s, box-shadow 0.2s",

                }}
                onClick={() => handleGalleryImageClick(filteredIndex)}
                style={{ cursor: "pointer" }}
              >
                <span
                  style={{
                    position: "absolute",
                    bottom: "8px",
                    fontSize: "10px",
                    color: "white",
                    background: "black",
                    padding: "1px 2px",
                    left: "0px",
                    opacity: "1",
                    zIndex: "1",

                  }}
                >
                  {item.annotationsCount}
                </span>
                <img
                  src={`${process.env.REACT_APP_SERVER_BASEURL}${item.thumbUrl}`}
                  alt=""
                  style={{
                    width: filteredIndex === currentIndex ? "95%" : "100%",
                    height: filteredIndex === currentIndex ? "92px" : "100px",
                    objectFit: "fill",
                    opacity: filteredIndex === currentIndex ? "1" : "0.7",
                    cursor: "pointer",
                    padding: filteredIndex === currentIndex ? "0" : "6px 0px",
                    border:
                      filteredIndex === currentIndex
                        ? "4px solid white"
                        : "none",
                    borderRadius:
                      filteredIndex === currentIndex ? "4px" : "0px",
                    background: "#212D32B2",
                    marginTop: "2px",
                    position: "relative",
                  }}
                />
                {item.annotationsCount > 0 && (
                  <span
                    style={{
                      width: "12px",
                      textAlign: "center",
                      alignContent: "center",
                      height: "12px",
                      borderRadius: "50%",
                      top: "9px",
                      position: "absolute",
                      right: "4px",
                      fontSize: "8px",
                      background: "green",
                      color: "white",
                      opacity: "1",
                    }}
                  >
                    <img
                      src={TickMark}
                      alt=""
                      style={{
                        height: "6px",
                        width: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </span>
                )}
              </Box>
            ))}
          </Box>
        </div>
      ) : (
        ""
      )}
      <Dialog
        open={deleteProjectLabelModal}
        onClose={() => {
          setDeleteProjectLabelModal(false);
          localStorage.setItem("popupOpen", false.toString());
        }}
        PaperProps={{
          style: {
            boxShadow: "none",
            width: "50%",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "#2121210f",
            },
          },
        }}
      >
        <DialogTitle>Delete Project Label</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you want to delete this Label?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="calcelDeleteLabel" onClick={handleDeleteLabelClose}>
            Cancel
          </Button>
          <Button id="confirmDeleteLabel" onClick={handleProjectLabelDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ClassificationTopbar;
